export default {
      
  // 静态页面获取用户登录信息
    LOGIN: {
        url: '/ajax/json/account/info',
        param: []
    },
    SITE_NAV: {
      url: '/dpnav/siteNav',
      param: ['cityId']
    },
    EXTEND_NAV: {
      url: '/dpnav/expNav',
      param: ['cityId']
    }
      
  }
  


// WEBPACK FOOTER //
// ./modules/config/config.js